import React from 'react';
import './App.scss';
import { Route, Routes } from 'react-router-dom';
import WorkDetails from './container/WorkDetails/WorkDetails';
import Home from './container/Home/Home';

const App = () => {
    return (
        <div className='app'>
            <Routes> 
                <Route path='/' element={<Home/>}/>             
                <Route path='/workDetails' element={<WorkDetails/>}/>
            </Routes>
        </div>
    );
};

export default App;